<bit-header></bit-header>
<div class="lg:container relative z-10 pt-6 px-5 pb-12">
  <h1 class="text-center mt-12"><span i18n>فروش و خرید </span><span>{{currency.name}}</span></h1>
  <div class="trade-container p-4 2xl:p-8 mb-8">
    <div class="currency-icon">
      <img class="" height="66" width="66" [src]="currency.iconPath" [alt]="currency.name">
    </div>
    <div class="price-change-tag" [class.success]="currency.markets.irr.priceChange24H >=0"
         [class.danger]="currency.markets.irr.priceChange24H < 0">
      <h5><span i18n>٪</span><span dir="ltr">{{currency.markets.irr.priceChange24H}}</span></h5>
    </div>
    <div
      class="flex justify-center md:justify-between md:flex-row-reverse items-center flex-col mt-8 md:gap-8 2xl:gap-24">
      <div [class.text-center]="currency.id === 'USDT'" class="basis-0 flex-grow">
        <h5
          class="mb-2">{{currency.markets.irr.lastPrice.buy | number:'1.0-' + currency.markets.irr.quoteCurrencyPrecision}}
          <span i18n>تومان</span></h5>
      </div>
      <div *ngIf="currency.id !== 'USDT'" class="basis-0 flex-grow">
        <h5
          class="text-end">{{currency.markets.usdt.lastPrice.buy | number:'1.0-' + currency.markets.usdt.quoteCurrencyPrecision}}
          <span
            i18n>دلار</span></h5>
      </div>
    </div>
    <div [class.justify-center]="currency.id === 'USDT'" [class.md:justify-between]="currency.id !== 'USDT'" class="flex relative z-10 flex-col md:flex-row  md:gap-8 2xl:gap-24 mt-6 md:mt-1">
      <div *ngIf="currency.id !== 'USDT'"  class="market-card mb-5 md:mb-0">
        <h5 class="market-card__title mb-5 xl:mb-8 " i18n>اطلاعات بازار تتری</h5>
        <div class="flex flex-col justify-between xl:flex-row">
          <div class="flex items-center justify-around xl:flex-col mb-8 xl:mb-0 xl:gap-6">
            <p i18n>میانگین قیمت ۷ روز</p>
            <p><strong>{{currency.markets.usdt.avgPrice | number:'1.0-' + currency.markets.usdt.quoteCurrencyPrecision}}
              <span i18n>دلار</span></strong></p>
          </div>
          <div class="flex items-center justify-around xl:flex-col mb-8 xl:mb-0 xl:gap-6">
            <p i18n>بالاترین قیمت تا کنون</p>
            <p><strong>{{currency.markets.usdt.maxPrice | number:'1.0-' + currency.markets.usdt.quoteCurrencyPrecision}}
              <span i18n>دلار</span></strong></p>
          </div>
          <div class="flex items-center justify-around xl:flex-col xl:gap-6">
            <p i18n>حجم معاملات ۲۴ ساعت</p>
            <p><strong>{{currency.markets.usdt.volume24H | number:'1.0-' + currency.markets.usdt.quoteCurrencyPrecision}}
              <span i18n>دلار</span></strong></p>
          </div>
        </div>
      </div>
      <div class="market-card" [class.usdt-market]="currency.id === 'USDT'" >
        <h5 class="market-card__title mb-5 xl:mb-8" i18n>اطلاعات بازار ریالی</h5>
        <div [class.gap-4]="currency.id === 'USDT'" class="flex flex-col justify-between xl:flex-row">
          <div class="flex items-center justify-around xl:flex-col mb-8 xl:mb-0 xl:gap-6">
            <p i18n>میانگین قیمت ۷ روز</p>
            <p><strong>{{currency.markets.irr.avgPrice | number:'1.0-' + currency.markets.irr.quoteCurrencyPrecision}}
              <span
                i18n>تومان</span></strong></p>
          </div>
          <div class="flex items-center justify-around xl:flex-col mb-8 xl:mb-0 xl:gap-6">
            <p i18n>بالاترین قیمت تا کنون</p>
            <p><strong>{{currency.markets.irr.maxPrice | number:'1.0-' + currency.markets.irr.quoteCurrencyPrecision}}
              <span
                i18n>تومان</span></strong></p>
          </div>
          <div class="flex items-center justify-around xl:flex-col xl:gap-6">
            <p i18n>حجم معاملات ۲۴ ساعت</p>
            <p><strong>{{currency.markets.irr.volume24H | number:'1.0-' + currency.markets.irr.quoteCurrencyPrecision}}
              <span
                i18n>تومان</span></strong></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="trade-card mb-6">
    <form [formGroup]="tradeForm" (ngSubmit)="startTrading()">
      <div class="flex flex-col sm:flex-row sm:gap-4 md:gap-8">
        <div class="flex flex-col flex-grow">
          <div class="trade-type mb-8">
            <div class="selection" [class.selected]="tradeType === 'Buy'" (click)="changeTradeType('Buy')">
              <h5 i18n>خرید</h5>
            </div>
            <div class="selection" [class.selected]="tradeType === 'Sell'" (click)="changeTradeType('Sell')">
              <h5 i18n>فروش</h5>
            </div>
            <div
              class="active-selection"
              [class.buy]="tradeType === 'Buy'"
              [class.sell]="tradeType === 'Sell'"
              [style.--number-of-items]="2"
              [style.--selected-index]="tradeType === 'Buy' ? 0 : 1"
            ></div>
          </div>
          <div class="flex mb-6 sm:mb-0"
               [ngStyle]="{'flex-direction' : baseCurrencyFirst ? 'column' : 'column-reverse'}">
            <div class="flex flex-col">
              <p class="mb-2"><strong i18n>مقدار ({{currency.name}})</strong></p>
              <div class="flex items-stretch">
                <div class="input-container w-full">
                  <input formControlName="amount" dir="ltr" class="input w-full" Currency
                         [precision]="currency.markets.irr.baseCurrencyPrecision">
                  <div class="input-icon">
                    <img height="35" width="35" [src]="currency.iconPath" [alt]="currency.id">
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-end my-4 max-w-[500px] rtl:pl-4 ltr:pr-4">
              <svg (click)="baseCurrencyFirst = !baseCurrencyFirst"
                   class="rotate-90 cursor-pointer relative top-2 select-none" width="25" height="29"
                   viewBox="0 0 25 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2 7C1.44772 7 1 7.44772 1 8C1 8.55228 1.44772 9 2 9L2 7ZM24.7071 8.70711C25.0976 8.31658 25.0976 7.68342 24.7071 7.2929L18.3431 0.928934C17.9526 0.538409 17.3195 0.538409 16.9289 0.928933C16.5384 1.31946 16.5384 1.95262 16.9289 2.34315L22.5858 8L16.9289 13.6569C16.5384 14.0474 16.5384 14.6805 16.9289 15.0711C17.3195 15.4616 17.9526 15.4616 18.3431 15.0711L24.7071 8.70711ZM2 9L24 9L24 7L2 7L2 9Z"
                  fill="white"/>
                <path
                  d="M23 20C23.5523 20 24 20.4477 24 21C24 21.5523 23.5523 22 23 22L23 20ZM0.292893 21.7071C-0.0976314 21.3166 -0.0976315 20.6834 0.292892 20.2929L6.65685 13.9289C7.04738 13.5384 7.68054 13.5384 8.07107 13.9289C8.46159 14.3195 8.46159 14.9526 8.07107 15.3431L2.41421 21L8.07107 26.6569C8.46159 27.0474 8.46159 27.6805 8.07107 28.0711C7.68054 28.4616 7.04738 28.4616 6.65686 28.0711L0.292893 21.7071ZM23 22L1 22L1 20L23 20L23 22Z"
                  fill="white"/>
              </svg>
            </div>
            <div class="flex flex-col">
              <p class="mb-2"><strong i18n>قیمت واحد (تومان)</strong></p>
              <div class="flex items-stretch">
                <div class="input-container w-full">
                  <input formControlName="price" dir="ltr" class="input w-full" Currency
                         [precision]="currency.markets.irr.quoteCurrencyPrecision">
                  <div class="input-icon">
                    <img height="35" width="35" src="https://cdn.countryflags.com/thumbs/iran/flag-round-250.png"
                         alt="IRR">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col flex-grow justify-between items-center">
          <img class="hidden sm:block" src="assets/images/trade/trading.webp" alt="trading_logo" width="234" height="248">
          <button type="submit" class="btn btn-success w-full max-w-[500px] mx-auto" i18n>شروع معامله</button>
        </div>
      </div>
    </form>

  </div>
  <!-- TradingView Widget BEGIN -->
  <div *ngIf="currency.id !== 'USDT'" class="tradingview-widget-container">
    <div id="tradingview_64813"></div>
  </div>
  <!-- TradingView Widget END -->
  <div class="dynamic-content mt-20" [innerHTML]="currency.description"></div>


</div>
<ng-container *ngIf="faqList$ | async as faqList">
  <div *ngIf="faqList.length > 0"  class="faq">
    <div class="lg:container relative z-10 py-24 px-5">
      <h4 class="text-center mb-7" i18n>سوالات متداول</h4>
      <ng-container *ngFor="let faq of faqList">
        <div class="accordion-question" (click)="faq.isOpen = !faq.isOpen">
          <p class="text-lg flex-grow"><strong>{{faq.question}}</strong></p>
          <div>
            <svg [ngStyle]="{'transform': faq.isOpen ? 'scaleY(-1)' : 'scaleY(1)'}" width="22" height="12"
                 viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L11 11L21 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="accordion-answer"
             [ngStyle]="{'height': faq.isOpen ? answer.offsetHeight + 40 + 'px' : 0}">
          <p class="leading-7 m-6" [innerHTML]="faq.answer" #answer></p>
        </div>
      </ng-container>

    </div>
  </div>

</ng-container>
<bit-footer></bit-footer>
